import React from "react";
import {
  Alert,
  Space,
  Typography,
  Row,
  Col,
  Statistic,
  Divider,
} from "antd";
import { TrophyOutlined } from "@ant-design/icons";

const { Text } = Typography;

const BestOptionAlert = ({ bestOption, expectedDays, expectedMove }) => {
  if (!bestOption) return null;

  return (
    <Alert
      message={
        <Space>
          <TrophyOutlined style={{ fontSize: 20, color: "#faad14" }} />
          <Text strong style={{ fontSize: 16 }}>
            🛡️ Most Robust Strike: ${bestOption.strike}
          </Text>
          <Text type="secondary" style={{ fontSize: 13 }}>
            (Best risk-adjusted performance even if signal misses)
          </Text>
        </Space>
      }
      description={
        <div>
          <Row gutter={16} style={{ marginTop: 12 }}>
            <Col span={6}>
              <Statistic
                title="Perfect Scenario"
                value={bestOption.returnPct}
                precision={2}
                suffix="%"
                valueStyle={{ color: "#3f8600", fontSize: 18 }}
              />
              <Text type="secondary" style={{ fontSize: 12 }}>
                ${bestOption.priceChange.toFixed(2)} profit
              </Text>
            </Col>
            <Col span={6}>
              <Statistic
                title="Avg Return"
                value={bestOption.avgReturn}
                precision={2}
                suffix="%"
                valueStyle={{ fontSize: 18 }}
              />
              <Text type="secondary" style={{ fontSize: 12 }}>
                Across {bestOption.scenariosTested} scenarios
              </Text>
            </Col>
            <Col span={6}>
              <Statistic
                title="Worst Case"
                value={bestOption.minReturn}
                precision={2}
                suffix="%"
                valueStyle={{
                  color: bestOption.minReturn > 0 ? "#3f8600" : "#ff4d4f",
                  fontSize: 18,
                }}
              />
              <Text type="secondary" style={{ fontSize: 12 }}>
                ${bestOption.worstCaseProfit.toFixed(2)} profit
              </Text>
            </Col>
            <Col span={6}>
              <Statistic
                title="Reliability"
                value={bestOption.profitableRatio * 100}
                precision={0}
                suffix="%"
                valueStyle={{ fontSize: 18 }}
              />
              <Text type="secondary" style={{ fontSize: 12 }}>
                {bestOption.profitableScenarios}/{bestOption.scenariosTested}{" "}
                profitable
              </Text>
            </Col>
          </Row>
          <Divider style={{ margin: "12px 0" }} />
          <Text>
            <strong>Why this strike?</strong> Tested across ±2 days (
            {expectedDays - 2} to {expectedDays + 2}) and ±2% moves (
            {expectedMove - 2}% to {expectedMove + 2}%). Stays profitable in{" "}
            {(bestOption.profitableRatio * 100).toFixed(0)}% of scenarios, even
            if timing or move % is off.
          </Text>
        </div>
      }
      type="success"
      style={{ marginBottom: 24 }}
    />
  );
};

export default BestOptionAlert;
